import './menu_button_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { label: String }

  showFloatingLabel = (event: Event): void => {
    if (this.label.length === 0) return
    this.floatingLabelController.show(this.label)
  }

  hideFloatingLabel = (event: Event): void => {
    this.floatingLabelController.hide()
  }

  updateFloatingLabel = (event: Event): void => {
    this.floatingLabelController.update(event)
  }

  get floatingLabelController (): object {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('floating_label'), 'floating-label')
  }

  get label (): string {
    return this.labelValue
  }
}
